export default __webpack_public_path__ + "static/media/card1.dce021fa.png";